<section class="page">
  <header class="page-header">
    <h2>Liste des cartouches livrées</h2>
    <p class="subtitle">Cartouches marquées comme livrées dans le système.</p>
  </header>

  <section class="panel">
    <button type="button" (click)="refresh()" [disabled]="loading">
      {{ loading ? 'Chargement...' : 'Actualiser la liste' }}
    </button>

    <div class="controls">
      <label>
        Filtre (id ou nom)
        <input
          type="text"
          [value]="filterValue"
          (input)="onFilterChange($any($event.target).value)"
          placeholder="Ex: 123 ou cartouche A"
        />
      </label>

      <label>
        Par page
        <select [value]="pageSize" (change)="onPageSizeChange($any($event.target).value)">
          @for (option of pageSizeOptions; track option) {
            <option [value]="option">{{ option }}</option>
          }
        </select>
      </label>
    </div>

    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (loading) {
      <p class="meta">Chargement des cartouches livrées...</p>
    } @else if (filteredItems.length === 0) {
      <p class="meta">Aucune cartouche livrée trouvée.</p>
    } @else {
      <p class="meta">
        {{ filteredItems.length }} cartouche(s) trouvée(s) - affichage {{ pageStart }} à {{ pageEnd }}.
      </p>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nom</th>
            </tr>
          </thead>
          <tbody>
            @for (item of pagedItems; track item.id) {
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.nom }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <button type="button" (click)="goToPreviousPage()" [disabled]="currentPage <= 1">
          Précédent
        </button>
        <span>Page {{ currentPage }} / {{ totalPages }}</span>
        <button type="button" (click)="goToNextPage()" [disabled]="currentPage >= totalPages">
          Suivant
        </button>
      </div>
    }
  </section>
</section>
